export default "__VITE_ASSET__K4DD_VpM__"